import { render, staticRenderFns } from "./LeftArrowIcon.vue?vue&type=template&id=31d68131&"
import script from "./LeftArrowIcon.vue?vue&type=script&lang=js&"
export * from "./LeftArrowIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports